import { useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { breadcrumbsHeaderState } from 'shared/components';
import { getPath, Path } from 'urlBuilder';

import { useBoardNavItems } from '../../../resources/hooks/useBoardNavItems';
import { messages } from '../messages';

export const useBreadcrumbs = () => {
    const setBreadcrumbs = useSetAtom(breadcrumbsHeaderState);
    const { items } = useBoardNavItems();
    const { boardId } = useParams<{ boardId: string }>();

    const breadcrumbs = useMemo(() => {
        const currentItem = items.find(({ value }) => value === boardId);

        return [
            {
                name: messages.title,
                to: getPath(Path.customerFeedback),
            },
            {
                value: currentItem?.to,
                subItems: items.map(({ label, to }) => ({
                    name: label,
                    to,
                })),
            },
        ];
    }, [boardId, items]);

    useEffect(() => {
        setBreadcrumbs(breadcrumbs);
    }, [breadcrumbs, setBreadcrumbs]);
};
